import { Bell } from 'lucide-react';
import { ChannelSettingsPage } from '@/features/marketing-shared/ui/channel-settings-page';
import { Card } from '@/shared/ui/card';

export function PushSettingsPage() {
  return (
    <ChannelSettingsPage
      title="Envio"
      description="O push não tem a página de templates do e-mail e não consome a cota de e-mail nem a de SMS."
      loadingLabel="Carregando o envio"
      errorTitle="Não foi possível carregar o envio"
    >
      <Card className="p-4 sm:p-5">
        <div className="flex items-start gap-3">
          <Bell className="mt-0.5 size-4 text-primary" />
          <div>
            <h2 className="text-sm font-medium">Disparo no aplicativo</h2>
            <p className="mt-1 text-sm text-muted-foreground">
              Cada campanha guarda horário, audiência e mensagem. Pausar na lista interrompe o disparo sem apagar esse conteúdo.
            </p>
          </div>
        </div>
      </Card>
    </ChannelSettingsPage>
  );
}
